import imgs from './../img/set/*.JPG';

export const state = {
    customAmountOfItems: 0,
    amountOfQuestions: 0,
    userAnswers: {
        correct: 0,
    },
};

const shuffle = (arr) => arr.sort(() => Math.random() - 0.5);

const randomImg = (arr) => Math.round(Math.random() * (arr.length - 1));

export const preloadImages = function () {
    state.customAmountOfItems = +document.getElementById('amount').value;
    state.amountOfQuestions = +document.getElementById('exam').value;

    let images = [],
        toAsk = [];

    Object.keys(imgs).forEach((img, i) => {
        images[i] = new Image();
        images[i].src = imgs[img];
        images[i].id = i + 1;
    });

    shuffle(images);

    const toShow = images;
    const notShown = images.splice(state.customAmountOfItems);

    let tempArrShown = toShow.slice(0);
    let tempArrNotShown = notShown.slice(0);

    Array.from({ length: state.amountOfQuestions }).forEach((_, i) => {
        let randImgNotShown = randomImg(tempArrNotShown);
        let randImgShown = randomImg(tempArrShown);

        toAsk[i] = [
            tempArrNotShown[randImgNotShown],
            tempArrShown[randImgShown],
        ];

        tempArrNotShown.splice(randImgNotShown, 1);
        tempArrShown.splice(randImgShown, 1);
    });

    console.log(toShow, toAsk);
    return [toShow, toAsk];
};
